// import './BannerDescription.scss';

import React from 'react';

export function BannerDescription({ promoLink } = {}) {
  return <div className='sertificat__text'>
    <div>
      <p className='sertificat__text__paragraph'>
        Кіно стає доступне для глядачів з порушенням зору та слуху!
      </p>
      <p className='sertificat__text__paragraph'>
        Переважна більшість фільмів,  які сьогодні демонструються в репертуарі кінотеатру мають  адаптовану версію для глядачів з порушенням зору та слуху.  Тому, щоб забезпечити доступність відеоконтенту  для незрячих і  нечуючих друзів,  ми радимо вам завантажити застосунки (додатки), які підтримує той чи іншій фільм.
      </p>
      <p className='sertificat__text__paragraph'>
        В описі кожного фільму на сайті
        {' '}<a href="#" style={{ color: '#73233c', fontWeight: '700' }}>https://zhovten-kino.kyiv.ua</a>{' '}
        вказано який саме застосунок  вам потрібно  обрати для адаптованого кіноперегляду цього фільму. Там же розміщено й посилання для завантаження.
      </p>
      <p className='sertificat__text__paragraph'>
        Ви чи ваші друзі можете завантажити застосунок  самостійно перейшовши за посиланням  на сайті кінотеатру  «Жовтень»  чи звернувшись до адміністратора або касира.
      </p>
      <p className='sertificat__text__paragraph'>
        Усі застосунки безкоштовні для завантаження з{' '}
        <span className="font-bold">App Store</span>
        {' '}або{' '}
        <span className="font-bold">Google Play</span>.
      </p>
      <p className='sertificat__text__paragraph'>
        Перелік застосунків, які допомагають дивитися адаптовані версії фільмів:{' '}
        <span className="font-bold">Earcatch</span>,{' '}
        <span className="font-bold">Subcatch</span>,{' '}
        <span className="font-bold">Greta</span>,{' '}
        <span className="font-bold">MovieReading</span>,{' '}
        <span className="font-bold">Подив</span>.
      </p>
      <p className='sertificat__text__paragraph'>
        Для перегляду фільму з адаптованими субтитрами треба повідомити адміністрацію кінотеатру перед показом.
      </p>

    </div>
  </div >
}




// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/HearingAndVisionImpairmentsV2/impl/BannerDescription.jsx